// extracted by mini-css-extract-plugin
export default {"PostsGrid":"PostsGrid_PostsGrid__vivtH","PostsGrid__Grid":"PostsGrid_PostsGrid__Grid__wIRVJ","PostsGrid__Ad":"PostsGrid_PostsGrid__Ad__7wmqW"};